import React from "react";
import { fmtDecimal, fmtInt } from "../sandbox/resumenData";
import { KpiRail, Rail, type MobileKpi } from "./MobileCards";

export interface MobileLocalCard {
  id: string;
  name: string;
  tag: { label: string; cls: string };
  attention: boolean;
  avg: number | null;
  starsTotal: number;
  curAvg: number | null;
  curN: number;
  critOpen: number;
  delta: { text: string; tone: "good" | "bad" | "flat" };
}

/** Locales en el teléfono: indicadores y una tarjeta por local, ambos en carrusel. */
export function LocalesMobile({
  kpis,
  locals,
  onOpen,
}: {
  kpis: MobileKpi[];
  locals: MobileLocalCard[];
  onOpen: (id: string) => void;
}) {
  return (
    <div className="rz">
      <KpiRail kpis={kpis} />
      <Rail label="Locales">
        {locals.map((l) => (
          <article key={l.id} className={`rz-local${l.attention ? " critical" : ""}`}>
            <header>
              <strong>{l.name}</strong>
              <span className={`sbx-loc-tag ${l.tag.cls}`}>{l.tag.label}</span>
            </header>
            <div className="val">
              <strong>{l.avg !== null ? fmtDecimal(l.avg) : "-"}</strong>
              <span>de 5 · {fmtInt(l.starsTotal)} reseñas</span>
            </div>
            <dl>
              <div>
                <dt>Nota del período</dt>
                <dd>{l.curAvg !== null ? fmtDecimal(l.curAvg) : "-"}</dd>
              </div>
              <div>
                <dt>Reseñas nuevas</dt>
                <dd>{fmtInt(l.curN)}</dd>
              </div>
              <div>
                <dt>Sin responder</dt>
                <dd className={l.critOpen > 0 ? "bad" : undefined}>{fmtInt(l.critOpen)}</dd>
              </div>
            </dl>
            <span className={`delta ${l.delta.tone}`}>{l.delta.text}</span>
            <button type="button" onClick={() => onOpen(l.id)}>
              Ver detalle
            </button>
          </article>
        ))}
      </Rail>
    </div>
  );
}
